import styled from "@emotion/styled";
import { ListGroup, ListGroupProps } from "react-bootstrap";
import { IStyledComponentProps } from "../../theme/theme.types";

const AdminPanelContainer = styled.div<IStyledComponentProps>`
  &.admin-panel-container {
    height: 100%;
    padding: 80px 0 0 0;
    margin: 0;
    &.force-scroll {
      overflow-y: scroll;
    }
  }
`;

const DroppedPinListContainer = styled.div<IStyledComponentProps>`
  &.dropped-pin-list-container {
    height: 100%;

    h1 {
      font-family: ${(props) => props.theme.fontFamilies.semiBold};
      font-size: ${(props) => props.theme.fontSizes.large}px;
      text-align: center;
      margin-bottom: 12px;
    }

    .spinner-container {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
      align-items: center;
      justify-items: center;
      .spinner-border {
        display: block;
      }
    }

    .list-wrapper {
      height: 100%;
      padding-bottom: 2em;
      overflow-y: auto;
    }
  }
`;

const DroppedPinListItem = styled(ListGroup.Item)<IStyledComponentProps>`
  &.dropped-pin-list-item {
    padding: 0.75rem 0 0.75rem 32px;
    .detail-container {
      .col,
      .col-3 {
        margin: 0;
        padding: 0;
      }

      .col-3 {
        font-family: ${(props) => props.theme.fontFamilies.semiBold};
      }
    }
  }
`;

const NoResultsContainer = styled.div<IStyledComponentProps>`
  &.no-results-container {
    height: 100%;
    text-align: center;
    padding: 28px 0 0 0;
  }
`;

export default {
  AdminPanelContainer,
  DroppedPinListContainer,
  DroppedPinListItem,
  NoResultsContainer,
};
